import { requestV2 } from 'store/common/utils';
export const getContentManagersApi = (q, signal) => requestV2({
    url: '/content-managers',
    method: 'GET',
    params: q ? { q } : undefined,
    signal,
    headers: { 'x-api-scope': 'admin' },
});
